import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import {
  Table,
  Header,
  Form,
  Select,
  Button,
  Icon,
  Modal,
  Input,
} from 'semantic-ui-react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { useStore } from '../../app/stores/store';
import { toast } from 'react-toastify';
import { shiftRoasterData } from '../../app/models/adlData';

function ShiftModify() {
  const { PivotStore, ADLtrackingStore, RestorationStore } = useStore();

  const [shiftRoasterData, setshiftRoasterData] = useState<
    {
      employee_ID?: string;
      lead: string;
      employeeId: string;
      shiftCode: string;
      startDate: string;
      endDate: string;
      shiftExtension: boolean;
      shiftExtensionDate: string;
    }[]
  >([]);
  const [actionNameModify, setActionNameModify] = useState('');
  const currentDate = new Date();
  const [showModal, setShowModal] = useState(false);
  const [startDate, setStartDate] = useState(() => {
    return moment(currentDate).format('YYYY-MM-DD');
  });
  const [shifCode, setShifCode] = useState<
    { key: string; value: string; text: string }[]
  >([]);
  const [titleCode, setTitleCode] = useState<
    { key: string; value: string; text: string }[]
  >([]);
  const [endDate, setendDate] = useState(() => {
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const day = String(currentDate.getDate()).padStart(2, '0');
    return `${month}-${day}-${year}`;
  });
  const [shiftModifyData, setShiftModifyData] = useState(false);
  const [currentShiftCode, SetCurrentShiftCode] = useState('');
  const [currentEmployeeID, SetcurrentEmployeeID] = useState('');
  const [shiftStartDate, setShiftStartDate] = useState('');
  const [leadIdLoad, setLeadIdLoad] = useState<
    { key: string; value: string; text: string }[]
  >([]);
  const [passPlID, setPlID] = useState('');
  const [shiftExtendtion, setShiftExtendtion] = useState(1);
  const [showShiftChange, setShowShiftChange] = useState(false);
  const [currentTitleCode, setCurrentTitleCode] = useState('');

  const [newShiftCode, setNewShiftCode] = useState('');
  const [reasons, setReasons] = useState('');
  useEffect(() => {
    ADLtrackingStore.loadLeadId();
    RestorationStore.getTitleCode();
    // const projectCode = RestorationStore.titleCodeData;
    // const titleCodelist = projectCode.map((data: string) => ({
    //   key: data,
    //   text: data,
    //   value: data,
    // }));
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    const leaddata = ADLtrackingStore.plEmpIdGet?.map((data: string) => {
      return {
        key: data,
        text: data,
        value: data,
      };
    });
    setLeadIdLoad(leaddata);
  }, [ADLtrackingStore.plEmpIdGet]);

  const viewDataHandler = async () => {
    try {
      const data = await ADLtrackingStore.loadShiftRoasterDatabyPL(
        startDate,
        endDate,
        passPlID,
      );
      setshiftRoasterData(data);
    } catch (error) {
      toast.error('Error fetching shift data');
    }
  };

  const setDate = (data: any, type: string) => {
    try {
      if (type === 'start') {
        setStartDate(moment(data).format('YYYY-MM-DD'));
      } else {
        if (type === 'end') setendDate(moment(data).format('YYYY-MM-DD'));
      }
    } catch (error) {
      toast.error('Error fetching Date');
    }
  };
  const setPL = (data: any) => {
    setPlID(data.value);
  };

  const editHandle = async (
    modifyShiftRoasterData: shiftRoasterData,
    actionName: string,
  ) => {
    try {
      setActionNameModify(actionName);
      await ADLtrackingStore.loadShiftcode();
      const adlShiftCode = ADLtrackingStore.shiftCodeList;
      const shifts = adlShiftCode.map((data: string) => ({
        key: data,
        text: data,
        value: data,
      }));
      setShifCode(shifts);
      setShowShiftChange(true);
      setShiftModifyData(false);
      setShowModal(true);
      setShiftStartDate(modifyShiftRoasterData.startDate);
      SetcurrentEmployeeID(modifyShiftRoasterData.employeeId);
      SetCurrentShiftCode(modifyShiftRoasterData.shiftCode);
    } catch (error) {
      toast.error('Error loading shift codes');
    }
  };

  const okHandler = async (actionName: string) => {
    if (actionName === 'edit') {
      if (
        showShiftChange === true &&
        currentEmployeeID &&
        currentShiftCode &&
        newShiftCode &&
        reasons &&
        startDate
      ) {
        let payLoads = {
          employee_ID: currentEmployeeID,
          previousShiftCode: currentShiftCode,
          newShiftCode: newShiftCode,
          reason: reasons,
          startDate: shiftStartDate,
        };

        await ADLtrackingStore.chanageShift(payLoads);
        setNewShiftCode('');
        SetcurrentEmployeeID('');
        SetCurrentShiftCode('');
        setReasons('');
        setShowModal(false);
        toast.success(ADLtrackingStore.shiftChange);
        viewDataHandler();
      } else {
        toast.error('Please Fill All data!');
      }
    } else if (actionName === 'extend') {
      let payLoadExts = {
        employee_ID: currentEmployeeID,
        shiftCode: currentShiftCode,
        extStartDate: shiftStartDate,
        extendtionHr: shiftExtendtion,
        reason: reasons,
        projectName: currentTitleCode,
      };

      await ADLtrackingStore.extShiftData(payLoadExts);
      setNewShiftCode('');
      SetcurrentEmployeeID('');
      SetCurrentShiftCode('');
      setReasons('');
      setShowModal(false);
      toast.success(ADLtrackingStore.shiftExtendition);
      viewDataHandler();
    } else {
      toast.error('Something went wrong. Please try again !');
    }
  };
  const handleShiftCodeChange = (event: any, data: any) => {
    setNewShiftCode(data.value);
  };
  const handleTitleCodeChange = (event: any, data: any) => {
    setCurrentTitleCode(data.value);
  };
  const handleShiftExtendtionChange = (event: any) => {
    const newValue = parseInt(event.target.value);
    setShiftExtendtion(newValue);
  };
  const shiftExtendition = (
    modifyShiftRoasterData: shiftRoasterData,
    actionName: string,
  ) => {
    setActionNameModify(actionName);
    RestorationStore.getTitleCode();
    const projectCode = RestorationStore.titleCodeData;
    const titleCodelist = projectCode.map((data: string) => ({
      key: data,
      text: data,
      value: data,
    }));
    setTitleCode(titleCodelist);
    setShowModal(true);
    setShowShiftChange(false);
    setShiftModifyData(true);
    setShiftStartDate(modifyShiftRoasterData.startDate);
    SetcurrentEmployeeID(modifyShiftRoasterData.employeeId);
    SetCurrentShiftCode(modifyShiftRoasterData.shiftCode);
  };
  return (
    <>
      <div className="title-wise-table">
        <div
          className="new-report-form-wrapper"
          style={{ width: '90%', margin: 'auto' }}
        >
          <Header style={{ marginLeft: '15px', marginTop: '10px' }}>
            Shift Details
          </Header>
          <Form>
            <Form.Group widths="equal" style={{ marginLeft: '15px' }}>
              <Form.Field
                id=""
                label="Lead Id"
                control={Select}
                filter
                Selection
                search
                clearable
                options={leadIdLoad}
                placeholder="Lead Id"
                required
                onChange={(event: any, data: any) => setPL(data)}
              />
              <Form.Field required={true}>
                <label>From Date</label>
                <DatePicker
                  placeholderText="From Date"
                  value={
                    startDate
                      ? PivotStore.dateFormat(
                          moment(startDate).format('YYYY-MM-DD'),
                        )
                      : ''
                  }
                  className="date-picker-style"
                  showMonthDropdown
                  showYearDropdown
                  locale={'en'}
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={15}
                  maxDate={moment().toDate()}
                  scrollableYearDropdown
                  onChange={(date: any) => setDate(date, 'start')}
                  popperProps={{ strategy: 'fixed' }}
                />
              </Form.Field>

              <Form.Field required={true}>
                <label>To Date</label>
                <DatePicker
                  placeholderText="To Date"
                  value={
                    endDate
                      ? PivotStore.dateFormat(
                          moment(endDate).format('YYYY-MM-DD'),
                        )
                      : ''
                  }
                  className="date-picker-style"
                  showMonthDropdown
                  showYearDropdown
                  locale={'en'}
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={15}
                  maxDate={moment().add(7, 'days').toDate()}
                  scrollableYearDropdown
                  onChange={(date: any) => setDate(date, 'end')}
                  popperProps={{ strategy: 'fixed' }}
                />
              </Form.Field>
              <Form.Field>
                <br />
                <Button onClick={viewDataHandler}>
                  <Icon name="list alternate outline" /> View Data{' '}
                </Button>
              </Form.Field>
            </Form.Group>
          </Form>
          <Modal
            open={showModal}
            onClose={() => setShowModal(false)}
            size="small"
          >
            <Modal.Content>
              <Form>
                <Form.Group widths="equal">
                  <Form.Field
                    control={Input}
                    fluid
                    label="Employee ID"
                    value={currentEmployeeID}
                    disabled
                    readOnly
                  />
                  <Form.Field
                    control={Input}
                    fluid
                    label="Curent Shift Code"
                    value={currentShiftCode}
                    disabled
                    readOnly
                  />
                  <Form.Field
                    control={Input}
                    fluid
                    label="Current Date"
                    value={moment(shiftStartDate).format('DD-MM-YYYY')}
                    disabled
                    readOnly
                  />
                  <Form.Field
                    control={Input}
                    fluid
                    label="Reason"
                    value={reasons}
                    onChange={(event: any) => setReasons(event.target.value)}
                  />

                  {showShiftChange && (
                    <Form.Field
                      label="Shift Code"
                      control={Select}
                      filter
                      selection
                      search
                      clearable
                      options={shifCode}
                      placeholder="Shift Code"
                      required
                      onChange={handleShiftCodeChange}
                    />
                  )}
                </Form.Group>
                {shiftModifyData && (
                  <React.Fragment>
                    <Form.Group widths="equal">
                      <Form.Field
                        label="Shift Extendtion"
                        control={Input}
                        type="range"
                        min={0}
                        max={8}
                        value={shiftExtendtion}
                        onChange={handleShiftExtendtionChange}
                      />
                      <br />
                      <p>{`Shift Extension Value: ${shiftExtendtion}`}</p>
                      <Form.Field
                        label="Project Name"
                        control={Select}
                        filter
                        selection
                        search
                        clearable
                        options={titleCode}
                        placeholder="Select Title Code"
                        required
                        onChange={handleTitleCodeChange}
                      />
                    </Form.Group>
                  </React.Fragment>
                )}
              </Form>
            </Modal.Content>
            <Modal.Actions>
              <Button.Group>
                <Button
                  onClick={() => okHandler(actionNameModify)}
                  color="green"
                  inverted
                >
                  Submit
                </Button>
                <Button
                  onClick={() => setShowModal(false)}
                  color="red"
                  inverted
                >
                  Cancel
                </Button>
              </Button.Group>
            </Modal.Actions>
          </Modal>
        </div>
        <br />
        <div
          className="new-report-form-wrapper"
          style={{ width: '90%', margin: 'auto' }}
        >
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Lead Employee ID</Table.HeaderCell>
                <Table.HeaderCell>Employee ID</Table.HeaderCell>
                <Table.HeaderCell>Date</Table.HeaderCell>
                <Table.HeaderCell>Shift Code</Table.HeaderCell>
                <Table.HeaderCell>Shift Extendition</Table.HeaderCell>
                <Table.HeaderCell>Action</Table.HeaderCell>
              </Table.Row>
              <br />
            </Table.Header>
            <Table.Body>
              {shiftRoasterData.map((rowData, index) => (
                <Table.Row key={index}>
                  <Table.Cell>{rowData.lead}</Table.Cell>
                  <Table.Cell>{rowData.employeeId}</Table.Cell>
                  <Table.Cell>
                    {moment(rowData.startDate).format('DD-MM-YYYY')}
                  </Table.Cell>
                  <Table.Cell>{rowData.shiftCode}</Table.Cell>
                  <Table.Cell>
                    {rowData.shiftExtensionDate === '' ? 'No' : 'Yes'}
                  </Table.Cell>
                  <Table.Cell>
                    <Button.Group>
                      <Button onClick={() => editHandle(rowData, 'edit')}>
                        {' '}
                        <Icon name="edit" />
                      </Button>
                      <Button.Or />
                      <Button
                        onClick={() => shiftExtendition(rowData, 'extend')}
                      >
                        <i className="icons">
                          <i className="clock icon"></i>
                          <i className="top right corner add icon"></i>
                        </i>
                      </Button>
                    </Button.Group>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </div>
    </>
  );
}
export default observer(ShiftModify);
